import styled from '@emotion/styled';
import { Stack, tokens } from '@hotjar/hotsauce';

export const FullScreenContainer = styled(Stack)`
  height: 100%;
  gap: 0;
`;

export const FullScreenContent = styled(Stack)`
  height: 100%;
  flex-direction: column;

  @media screen and ${tokens.breakpoint.minWidth.l} {
    flex-direction: row;
  }
`;

export const FullScreenPanel = styled(Stack)<{ hiddenOnSmallScreen: boolean }>`
  display: block;
  padding: ${tokens.spacer.x5};

  ${({ hiddenOnSmallScreen }) => hiddenOnSmallScreen && 'display: none;'}

  & > :first-child {
    padding-bottom: ${tokens.spacer.x7};
    margin: auto;
  }

  &:not(:first-of-type) {
    background-color: ${tokens.color.bg_info};
  }

  @media screen and ${tokens.breakpoint.minWidth.l} {
    flex: 1;
    padding: 0 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const FullScreenFooter = styled(Stack)`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: ${tokens.spacer.x2} ${tokens.spacer.x3};
  background-color: ${tokens.color.ui_background};
  border-top: 1px solid ${tokens.color.ui_border_light};
  justify-content: flex-end;
`;
